import * as _ from 'lodash';
import { Injectable } from '@angular/core';

import { WindowService } from './window.service';
import { setItemAsJson, getItemAsJson } from 'helpers';

@Injectable()
export class ScrollService {
    private storedStates: string[];

    constructor(private windowService: WindowService) {
        this.storedStates = ['files', 'products', 'brands'];
    }

    public scroll(stateName) {
        const pageYOffset = this.getScrollPositions()[stateName];
        if (pageYOffset) {
            this.windowService.scrollTo(0, pageYOffset);
        }
    }

    public scrollClassElement(className) {
        const classYOffset = this.getScrollPositions()[className];
        const element = this.windowService.getElementByClassName(className);
        if (classYOffset && element) {
            element.scrollLeft = 0;
            element.scrollTop = classYOffset;
        }
    }

    public scrollIdElement(elementId) {
        const classYOffset = this.getScrollPositions()[elementId];
        const element = this.windowService.getElementById(elementId);
        if (classYOffset && element) {
            element.scrollLeft = 0;
            element.scrollTop = classYOffset;
        }
    }

    public storePos(stateName) {
        if (_.includes(this.storedStates, stateName)) {
            const scrollPositions = this.getScrollPositions();
            scrollPositions[stateName] = this.windowService.pageYOffset;
            setItemAsJson('scrollPositions', scrollPositions);
        }
    }

    public storePosByClassName(className) {
        const scrollPositions = this.getScrollPositions();
        const element = this.windowService.getElementByClassName(className);
        if (element) {
            scrollPositions[className] = element.scrollTop;
            setItemAsJson('scrollPositions', scrollPositions);
        }
    }

    public storePosByElementId(elementId) {
        const scrollPositions = this.getScrollPositions();
        const element = this.windowService.getElementById(elementId);
        if (element) {
            scrollPositions[elementId] = element.scrollTop;
            setItemAsJson('scrollPositions', scrollPositions);
        }
    }

    public resetPos(stateName) {
        if (_.includes(this.storedStates, stateName)) {
            const scrollPositions = this.getScrollPositions();
            scrollPositions[stateName] = 0;
            setItemAsJson('scrollPositions', scrollPositions);
        }
    }

    public resetClassPosition(className) {
        const scrollPositions = this.getScrollPositions();
        scrollPositions[className] = 0;
        setItemAsJson('scrollPositions', scrollPositions);
    }

    public getScrollPositions() {
        const scrollPositions = getItemAsJson('scrollPositions') || {};
        return scrollPositions;
    }

    public scrollElementTop(elementId: string) {
        const element = this.windowService.getElementById(elementId);
        if (element) {
            element.scrollTop = 0;
        }
    }

    public scrollElementIntoViewIfNeeded(elementId: string, config = {}) {
        const element = this.windowService.getElementById(elementId);
        if (!element || this.isElementInViewport(element)) {
            return;
        }
        element.scrollIntoView(config);
    }

    private isElementInViewport(element: Element): boolean {
        const window = this.windowService.nativeWindow;
        const distance = element.getBoundingClientRect();

        return (
            distance.top >= 0 &&
            distance.left >= 0 &&
            distance.bottom <= (window.innerHeight || window.document.documentElement.clientHeight) &&
            distance.right <= (window.innerWidth || window.document.documentElement.clientWidth)
        );
    }
}
